import React from "react";
import SectionShell from "../layout/SectionShell";
import { experienceData } from "../../mock/portfolioData";

export function ExperienceSection() {
  return (
    <SectionShell id="experience" title="Experience" kicker="Timeline">
      <ol className="relative space-y-8 border-l border-slate-800 pl-5 text-sm text-slate-200">
        {experienceData.items.map((item) => (
          <li key={item.company} className="relative">
            <div className="absolute -left-2.5 top-1 h-2.5 w-2.5 rounded-full border border-cyan-400 bg-slate-900" />
            <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4 shadow-[0_0_22px_rgba(15,23,42,0.9)]">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <div>
                  <h3 className="text-sm font-semibold text-slate-50">
                    {item.role}
                  </h3>
                  <p className="text-xs text-slate-400">{item.company}</p>
                </div>
                <p className="font-mono text-[11px] font-medium text-cyan-300">
                  {item.period}
                </p>
              </div>
              <p className="mt-1 text-[11px] text-slate-400">{item.location}</p>
              <ul className="mt-3 list-disc space-y-1.5 pl-4 text-xs text-slate-300">
                {item.bullets.map((bullet) => (
                  <li key={bullet}>{bullet}</li>
                ))}
              </ul>
            </div>
          </li>
        ))}
      </ol>
    </SectionShell>
  );
}

export default ExperienceSection;
